import { render, staticRenderFns } from "./v-toggle.vue?vue&type=template&id=4cb57b67&scoped=true&"
import script from "./v-toggle.vue?vue&type=script&lang=js&"
export * from "./v-toggle.vue?vue&type=script&lang=js&"
import style0 from "./v-toggle.vue?vue&type=style&index=0&id=4cb57b67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb57b67",
  null
  
)

export default component.exports